import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7nbwqw0mwh: FaireBrandEntity = {
  token: "b_7nbwqw0mwh",
  type: "brand",
  name: "Current Air",
  avatarUrl:
    "https://cdn.faire.com/fastly/04f945e8912df6859b2414fb337e38626877faa28b77ba3e637b52c0074debe3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a52b2bb80d5134b3116a790081ec687035fd9282f2383e59fa2c5ff5082bc4f7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/04f945e8912df6859b2414fb337e38626877faa28b77ba3e637b52c0074debe3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a52b2bb80d5134b3116a790081ec687035fd9282f2383e59fa2c5ff5082bc4f7.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 47,
  isTopShop: true,
  isInsider: true,
  description:
    "Current Air is a contemporary fashion brand celebrating the modern woman and power of personal style. Our brand is where confidence meets fashion. \n\nRooted in the spirit of ease and confidence, Current Air blends timeless designs with a fresh, approachable aesthetic, providing stylish solutions for every wardrobe. \n\nSince our launch in 2016, we've created beautifully designed products using stunning fabrics - with pieces that  seamlessly integrate into an everyday wardrobe. Versatile, modern, and endlessly chic.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:41.943Z",
    importedBy: "entity-db-cli",
  },
};
